import { RootState } from "../../../store/rootReducer";
import { GenericAgentConversation } from "../types/agentConfig";
import { generateConversationKey } from "./genericAgentConversationsSlice";

/**
 * Select conversations for a specific agent and context
 */
export const selectConversationsForContext = (
  state: RootState,
  agentType: string,
  contextId: string,
  userId?: string
): GenericAgentConversation[] => {
  const key = generateConversationKey(agentType, contextId, userId);
  return state.genericAgentConversations.conversationsByKey[key] || [];
};

/**
 * Select loading status for a specific agent and context
 */
export const selectConversationsLoadingStatus = (
  state: RootState,
  agentType: string,
  contextId: string,
  userId?: string
): "idle" | "loading" | "succeeded" | "failed" => {
  const key = generateConversationKey(agentType, contextId, userId);
  return state.genericAgentConversations.loadingStates[key] || "idle";
};

/**
 * Select error message for a specific agent and context
 */
export const selectConversationsError = (
  state: RootState,
  agentType: string,
  contextId: string,
  userId?: string
): string | null => {
  const key = generateConversationKey(agentType, contextId, userId);
  return state.genericAgentConversations.errorMessages[key] || null;
};

/**
 * Select all conversations for debugging purposes
 */
export const selectAllGenericConversations = (state: RootState) => {
  return state.genericAgentConversations.conversationsByKey;
};

/**
 * Select if conversations are currently loading
 */
export const selectIsConversationsLoading = (
  state: RootState,
  agentType: string,
  contextId: string,
  userId?: string
): boolean => {
  const status = selectConversationsLoadingStatus(state, agentType, contextId, userId);
  return status === "loading";
};

/**
 * Select if conversations have been loaded successfully
 */
export const selectHasConversationsLoaded = (
  state: RootState,
  agentType: string,
  contextId: string,
  userId?: string
): boolean => {
  const status = selectConversationsLoadingStatus(state, agentType, contextId, userId);
  return status === "succeeded";
};